import { render, staticRenderFns } from "./BaseLogoWaveAnim.vue?vue&type=template&id=5145c45c&scoped=true&"
import script from "./BaseLogoWaveAnim.vue?vue&type=script&lang=js&"
export * from "./BaseLogoWaveAnim.vue?vue&type=script&lang=js&"
import style0 from "./BaseLogoWaveAnim.vue?vue&type=style&index=0&id=5145c45c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145c45c",
  null
  
)

export default component.exports